// Iterate over all the properties of an object and call a function for each one.
export function forEachIn(obj: any, fn: any) {
    var index = 0;
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            fn(obj[key], key, index++);
        }
    }
}


export function enumFromString<T>(enm: { [s: string]: T }, value: string): T | undefined {
  return (Object.values(enm) as unknown as string[]).includes(value)
    ? value as unknown as T
    : undefined;
}

// Take any number of objects and return a new object that has all of them merged together.
export function extend(...args: any[]): any {
    var result: any = {};
    for (var i = 0; i < arguments.length; i++) {
        forEachIn(arguments[i],
            function (obj: any, key: any) {
                result[key] = obj;
            });
    }
    return result;
}

export function debounce(func: any, that: any, delay: number) {
    let debounceTimer : any = 0;
    return function () {
        const context = that;
        const args = arguments;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => func.apply(context, args), delay);
    }  
}
  

/*
export function debounce<F extends Function>(func:F, wait:number):F {
  let timeoutID:number;

  if (!Number.isInteger(wait)) {
    console.warn("Called debounce without a valid number")
    wait = 300;
  }

  // conversion through any necessary as it wont satisfy criteria otherwise
  return <any>function(this:any, ...args: any[]) {
      clearTimeout(timeoutID);
      const context = this;

      timeoutID = window.setTimeout(function() {
		    func.apply(context, args);
      }, wait);
   };
  }
*/